import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Every new screen starts at the top.
//
// BrowserRouter swaps the screen without touching the scroll position, so a
// page opened from halfway down the last one opened halfway down itself. In
// the native app that put the logger's own header (the exit, the progress bar,
// the set count) above the top of the screen: the athlete landed on the logger
// scrolled past the controls that say where they are.
//
// Keyed on the pathname alone, so a query change on the same screen (a week
// picker writing ?day=2) does not throw the athlete back to the top.
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
